import {Role} from '@/types'
import apiClient from '@/utils/axios'
import {apiEndPoints} from '@/utils/constant'
import {AxiosResponse} from 'axios'

const {ROLE_URL} = apiEndPoints

interface RoleService{
  getRoles: () => Promise<AxiosResponse<Role[]>>
  getRoleById: (roleId: number) =>Promise<AxiosResponse<Role>>
  postRoles: (role: Role) => Promise<AxiosResponse<Role>>
  deleteRole: (role: number) => Promise<AxiosResponse<string>>
}

const role: RoleService = {
  async getRoles(): Promise<AxiosResponse<Role[]>> {
    const response = await apiClient.get(ROLE_URL)
    return response
},

  async getRoleById(roleId): Promise<AxiosResponse<Role>> {
    const response = await apiClient.get(`${ROLE_URL}/${roleId}`)
    return response
},

  async postRoles(role): Promise<AxiosResponse<Role>> {
    const response = await apiClient.post(ROLE_URL, role)
    return response
},

  async deleteRole(roleId): Promise<AxiosResponse<string>> {
    const response = await apiClient.delete(`${ROLE_URL}/${roleId}`)
    return response
},
}

export {role}
